import { createModeAwareDescriptor } from '@toolproof-core/visualization/adapter/mode-controller-delegation';
import type { SpaceAdapter } from '@toolproof-core/visualization/adapter/_contract/adapter';

import {
    DEFAULT_CONFIG,
    MODE_POLICY,
    createModeAugmentationResolver,
    createRuntimeEffectOwner,
    episodePresentation,
    resolveRuntimeConfig,
    runnerModeController,
} from '@/workflow/modes/_@shared/modeRegistration';
import { loadLocalTraces } from '@/workflow-runner/loadLocalTraces';
import { buildCosmosData } from '@/workflow/_pure/cosmosData';
import { getResourceTypeInputSpec } from '@/workflow/_pure/resourceTypeInputSpec';
import { createSpaceDeriver } from '@/workflow/framePipeline';
import { SPACE_KEY } from '@/workflow/spaceIdentity';
import type { InteractiveRuntimeState, PipelineContext } from '@/workflow/modes/_@shared/_contract/mode';
import type { Config, ResourceTypeRequirement } from '@/workflow/_contract/config';
import type { CosmosDataModel } from '@/workflow/_contract/cosmosData';

export const spaceAdapter: SpaceAdapter<
    ResourceTypeRequirement,
    CosmosDataModel,
    Config,
    InteractiveRuntimeState
> = {
    createSpaceDeriver: () => createSpaceDeriver<
        Config,
        InteractiveRuntimeState,
        PipelineContext
    >({
        resolveConfig: resolveRuntimeConfig,
        resolveModeAugmentation: createModeAugmentationResolver(),
    }),
};

export const DESCRIPTOR = { ...createModeAwareDescriptor<
    ResourceTypeRequirement,
    CosmosDataModel,
    Config,
    InteractiveRuntimeState
>({
    baseDescriptor: {
        spaceKey: SPACE_KEY,
        adapter: spaceAdapter,
        getResourceTypeInputSpec,
        buildCosmosData,
        defaultConfig: DEFAULT_CONFIG,
    },
    modePolicy: MODE_POLICY,
    fallbackController: runnerModeController,
}), loadSupplementalCosmosData: loadLocalTraces,
    episodePresentation,
    createRuntimeEffectOwner,
};

export type AdapterDescriptor = typeof DESCRIPTOR;
